import { gql } from '@apollo/client';

export * from './softwareEscrowUpdate.mutation.generated';

export const SOFTWARE_ESCROW_UPDATE = gql`
  mutation softwareEscrowUpdate($softwareEscrowId: ID!, $softwareEscrowParams: SoftwareEscrowUpdateParams!) {
    softwareEscrowUpdate(input: { softwareEscrowId: $softwareEscrowId, softwareEscrowParams: $softwareEscrowParams }) {
      success
      errors
      softwareEscrow {
        id
        activationNotification
        beneficiaryActivityNotification
        beneficiaryDisruptionNotification
        beneficiaryDisruptionNotificationGracePeriod
        beneficiarySharedInformation
        depositorActivityNotification
        depositorDisruptionNotification
        depositorDisruptionNotificationGracePeriod
        storageRegion
        assetVersionsLimit
      }
    }
  }
`;
